export default __webpack_public_path__ + "static/media/welcome.6d97977a.webp";